"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _title_styles = _interopRequireDefault(require("./title_styles"));

var _title_definition = _interopRequireDefault(require("./title_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// utils
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : TITLE ~~~~~~~~~~ ========== */


var Title = (0, _reactJss.default)(_title_styles.default)(function (props) {
  return _react.default.createElement("div", {
    className: "title ".concat((0, _index.generateClasses)(props), " ").concat(props.classes.title)
  }, props.children);
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(Title, _title_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = Title;
exports.default = _default;